function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "img-bank");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "UID",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Payment-Method",
  transform: "translate(-28.000000, -270.000000)"
}, React.createElement("g", {
  id: "img-bank",
  transform: "translate(28.000000, 270.000000)"
}, React.createElement("rect", {
  id: "base",
  fill: "#E5ECF3",
  x: 0,
  y: 0,
  width: 55,
  height: 55,
  rx: 10
}), React.createElement("text", {
  id: "BANK",
  fontFamily: "Lato-Bold, Lato",
  fontSize: 12,
  fontWeight: "bold",
  fill: "#004A8C"
}, React.createElement("tspan", {
  x: 11,
  y: 32
}, "BANK")))));

var SvgCardtypeBank = function SvgCardtypeBank(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "55px",
    height: "55px",
    viewBox: "0 0 55 55",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCardtypeBank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cardtype-bank.319cf15f.svg";
export { ForwardRef as ReactComponent };